import { render } from "./AppAbout.vue?vue&type=template&id=27cfa415"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__